import { defineEntity, custom } from './_helpers.js';

/** Dedicated file so lifecycle + reminder events stay grouped. */
export default defineEntity('assetLicense', {
    expiryReminder: custom({ scope: 'state' }),
});
